import { makeStyles } from 'tss-react/mui'
import { paneDividerColor } from '../../../assets/colors'

const useStyles = makeStyles()((theme) => ({
    container: {
        position: 'relative',
        display: 'inline-block',
        flexShrink: 0,
        zIndex: 4,
        pointerEvents: 'all',
        backgroundColor: theme.palette.divider,

        '&::before, &:after': {
            content: '\"\"',
            position: 'absolute',
            display: 'block'
        }
    },
    vertical: {
        '&:hover': {
            cursor: 'ew-resize',
            backgroundColor: paneDividerColor
        },
        '&::before': {
            width: '6px',
            height: '100%',
            top: 0,
            left: 0,
            transition: 'background-color 120ms ease'
        },
        '&::after': {
            width: '6px',
            height: '100%',
            left: '-6px',
            top: 0,
            transition: 'background-color 120ms ease'
        },
        '&:hover::before, &:hover::after': {
            backgroundColor: paneDividerColor
        }
    },
    horizontal: {
        '&:hover': {
            cursor: 'ns-resize',
            backgroundColor: paneDividerColor
        },
        '&::before': {
            height: '6px',
            width: '100%',
            left: 0,
            top: 0,
            transition: 'background-color 120ms ease'
        },
        '&::after': {
            height: '6px',
            width: '100%',
            top: '-6px',
            left: 0,
            transition: 'background-color 120ms ease'
        },
        '&:hover::before, &:hover::after': {
            backgroundColor: paneDividerColor
        }
    },
    hovered: {
        backgroundColor: paneDividerColor,
        '&::before, &:after': {
            backgroundColor: paneDividerColor
        }
    }
}))

export default useStyles
